import { getChannelAPIPath } from '@treasury/core/http';

RemoteDepositCaptureSsoService.$inject = ['$resource'];

export default function RemoteDepositCaptureSsoService($resource) {
    return {
        getRemoteDepositCaptureSsoLogin,
        getAdditionalRemoteDepositSettings,
    };

    function getRemoteDepositCaptureSsoLogin() {
        return $resource(
            `${getChannelAPIPath()}receivables/getRemoteDepositCaptureSsoLogin`,
            {},
            { get: { isArray: false } }
        ).get().$promise;
    }

    function getAdditionalRemoteDepositSettings() {
        return $resource(
            `${getChannelAPIPath()}users/getAdditionalRemoteDepositSettings`,
            {},
            { get: { method: 'GET', isArray: false } }
        ).get().$promise;
    }
}
